import { cn } from '@lib/utils';
import type { HTMLAttributes, ReactNode } from 'react';


export type GradientKey = 'primary' | 'blue' | 'purple' | 'aurora' | 'danger' | 'warning';

const GRADIENT: Record<GradientKey, string> = {
  primary: 'bg-gradient-primary',
  blue: 'bg-gradient-blue',
  purple: 'bg-gradient-purple',
  aurora: 'bg-gradient-aurora',
  danger: 'bg-gradient-danger',
  warning: 'bg-gradient-warning',
};

export interface GradientTextProps extends HTMLAttributes<HTMLSpanElement> {
  gradient?: GradientKey;
  as?: keyof JSX.IntrinsicElements;
  children: ReactNode;
}

/** Rule 17 — always use this for hero numbers and big stats. */
export function GradientText({
  gradient = 'primary',
  as: Tag = 'span',
  className,
  children,
  ...rest
}: GradientTextProps): JSX.Element {
  const Component = Tag as 'span';
  return (
    <Component
      className={cn('bg-clip-text text-transparent', GRADIENT[gradient], className)}
      {...rest}
    >
      {children}
    </Component>
  );
}
